import {colors} from '../styles/theme/colors';

const useTheme = () => {
  return {
    colors
  };
};

export default useTheme;
